export const SUBJECTS = [
  { code: 'ELA', name: 'ELA' },
  { code: 'MATH', name: 'Math' },
  { code: 'SCI', name: 'Science' }
  ];

export const effectivenessLevels = [
  { code: '1', name: 'Not high impact' },
  { code: '2', name: 'High Impact' }
]